import { defineStore } from "pinia";
import seeds from "../service/seeds";
import utils from '../service/utils';

const seedStore = defineStore("seed", {
  state: () => {
    return {
      seeds: [],
      sortAscending: false,
      selectedColumn: "",
      page: 1,
      numberOfPages: 0,
      loading: false,
      rawData: [],
      allSeeds: []
    };
  },
  actions: {
    async getSeedsByProductIdAndSeason(productId, season) {
      try {
        const res = await seeds.getSeedsByProductIdAndSeason(productId, season);
        return res.seeds;
      } catch (e) {
        throw e;
      }
    },
    async getSeeds(q) {
      try {
        this.seeds = [];
        this.loading = true;
        const res = await seeds.getSeeds(this.page, q);
        this.seeds = res.seeds;
        this.numberOfPages = res.numberOfPages;
        this.loading = false;

        return res.seeds;
      } catch (e) {
        throw e;
      }
    },
    goToNextPage() {
      this.page = this.page + 1;
      this.getSeeds();
    },
    goToPreviousPage() {
      if (this.page) {
        // I think it's if (this.page + 1)
        this.page = this.page - 1;
        this.getSeeds();
      }
    },

    async getAllSeeds(getAll) {
      try {
        // get all with no pagination
        this.seeds = [];
        const res = await seeds.getSeeds(getAll);
        this.allSeeds = res.seeds;
      } catch (e) {
        throw e;
      }
    },

    async getSeedById(id) {
      try {
        const res = await seeds.getSeedsById(id);
        return res;
      } catch (e) {
        throw e;
      }
    },

    async getNames() {
      try {
        const res = await seeds.getNames();
        return res.result;
      } catch (e) {
        throw e;
      }
    },
    async createSeed(seed) {
      try {
        const res = await seeds.createSeed(seed);
        console.log(res.result);
      } catch (e) {
        throw e;
      }
    },
    async removeSeed(id) {
      try {
        await seeds.removeSeed(id);
        this.seeds = this.seeds.filter((s) => s._id !== id);
      } catch (e) {
        throw e;
      }
    },
    async updateSeed(id, seed) {
      try {
        const res = await seeds.updateSeed(id, seed);
      } catch (e) {
        throw e;
      }
    },
    sortSeeds(key) {
      // I'm going to assume that 'true' means 'ascending' order. 
      // In which case, why wasnt name 'ascendingOrder' instead?
      this.sortAscending = !this.sortAscending;
      let clone = [...this.seeds];
      if (["product", "name", "provider", "format"].includes(key)) {
        clone.sort(utils.alphabeticSorting(key, this.sortAscending));
      } else if (["price", "quantity"]) {
        clone.sort(utils.numericalSorting(key, this.sortAscending));
      }
      this.seeds = [...clone];
    },
  },
});

export default seedStore;
